export const resolveMachine = (machines, value, customerAbbreviation) => {
  const label = String(value || "").trim();
  const candidates = customerAbbreviation
    ? machines.filter((machine) => machine.Abbreviation === customerAbbreviation)
    : machines;
  const serialNo = label.match(/\(([^()]+)\)\s*$/)?.[1] || label;
  const matches = (value) => String(value ?? "").trim() === label;

  const machine = candidates.find((entry) =>
    [entry.Name, entry.MachineName, entry.MachineFullName].some(matches)
  ) || candidates.find((entry) =>
    String(entry.SerialNo || entry.MachineSerialNo || "").trim() === serialNo
  );

  return {
    machineName: machine?.MachineName || machine?.Name || machine?.MachineFullName,
    machineSerialNo: machine?.SerialNo || machine?.MachineSerialNo,
  };
};
